export default "__VITE_ASSET__CZIkK$nK__"